module.exports = __webpack_public_path__ + "img/DSC_0044.e7b3e186.jpg";